/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { PropTypes as MicromagPropTypes } from '@micromag/core';

import Menu from './Menu';
import ScreenDeleteModal from '../modals/ScreenDelete';
import ScreenDuplicateModal from '../modals/ScreenDuplicate';

const propTypes = {
    story: MicromagPropTypes.story.isRequired,
    screen: MicromagPropTypes.screen.isRequired,
    onStoryChange: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    onStoryChange: null,
    className: null,
};

const ScreenMenu = ({
    story,
    screen,
    onStoryChange,
    className,
    ...props
}) => {
    const [duplicateModalOpened, setDuplicateModalOpened] = useState(false);
    const [deleteModalOpened, setDeleteModalOpened] = useState(false);

    const onDeleteScreenOpenModal = useCallback(
        (e) => {
            e.preventDefault();
            setDeleteModalOpened(true);
        },
        [setDeleteModalOpened],
    );

    const onDuplicateScreenOpenModal = useCallback(
        (e) => {
            e.preventDefault();
            setDuplicateModalOpened(true);
        },
        [setDeleteModalOpened],
    );

    const onDeleteComplete = useCallback((newStory) => {
        setDeleteModalOpened(false);
        if (onStoryChange !== null) {
            onStoryChange(newStory);
        }
    }, [setDeleteModalOpened, onStoryChange]);

    const onDeleteCancel = useCallback(() => {
        setDeleteModalOpened(false);
    }, [setDeleteModalOpened]);

    const onDuplicateComplete = useCallback((newStory) => {
        setDuplicateModalOpened(false);
        if (onStoryChange !== null) {
            onStoryChange(newStory);
        }
    }, [setDuplicateModalOpened, onStoryChange]);

    const onDuplicateCancel = useCallback(() => {
        setDuplicateModalOpened(false);
    }, [setDuplicateModalOpened]);
    

    const finalItems = useMemo(() => [
        {
            id: 'duplicate',
            href: null,
            onClick: onDuplicateScreenOpenModal,
            label: (
                <FormattedMessage defaultMessage="Duplicate" description="Menu label" />
            ),
        },
        {
            id: 'delete',
            href: null,
            onClick: onDeleteScreenOpenModal,
            label: <FormattedMessage defaultMessage="Delete" description="Menu label" />,
        },
    ], []);
    return (
        <>
            <Menu
                items={finalItems}
                asDropdown
                className={className}
                {...props}
            />
            {deleteModalOpened ? (
                <ScreenDeleteModal
                    story={story}
                    screen={screen}
                    onComplete={onDeleteComplete}
                    onCancel={onDeleteCancel}
                />
            ) : null}
            {duplicateModalOpened ? (
                <ScreenDuplicateModal
                    story={story}
                    screen={screen}
                    onComplete={onDuplicateComplete}
                    onCancel={onDuplicateCancel}
                />
            ) : null}
        </>
    );
};

ScreenMenu.propTypes = propTypes;
ScreenMenu.defaultProps = defaultProps;

export default ScreenMenu;
